import { render, staticRenderFns } from "./paymentResult.vue?vue&type=template&id=eb573ec0&scoped=true&"
import script from "./paymentResult.vue?vue&type=script&lang=js&"
export * from "./paymentResult.vue?vue&type=script&lang=js&"
import style0 from "./paymentResult.vue?vue&type=style&index=0&id=eb573ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb573ec0",
  null
  
)

export default component.exports